'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plugins = exports.Component = exports.ComponentManager = undefined;

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _ComponentManager = require('./ComponentManager');

var _ComponentManager2 = _interopRequireDefault(_ComponentManager);

var _plugins = require('./plugins');

var plugins = _interopRequireWildcard(_plugins);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ComponentManager = _ComponentManager2.default;
exports.Component = _Component2.default;
exports.plugins = plugins;